import { HtmlContentHeuristic } from '../../../interfaces/html-content-heuristic';
import { fontWeight } from '../html-content-properties/font-weight';
import { textLength } from '../html-content-properties/text-length';

// break when the text is bold and there is a decent amount of text
export const breakOnBold: HtmlContentHeuristic = {
  reason: 'the text is bold and there are a lot of characters',
  evaluate: (next: Record<string, any>) => +next.fontWeight > 400 && next.textLength > 1500,
  properties: [fontWeight, textLength]
};
